import React, { useState } from "react";
import Button from "components/button";
import IndexModal from "components/modal";
import { Sparkles, Trophy } from "lucide-react";


const NotificationButton = ({
    children,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button
                onClick={() => setIsOpen(true)}
                className="access-button btn-notif"
            >
                <Trophy className="w-4 h-4 mr-2" />
                <span>Special Notifications</span>
                <div className="ml-2">
                    <Sparkles className="w-4 h-4" />
                </div>
            </Button>

            <IndexModal
                open={isOpen}
                onClose={() => setIsOpen(false)}
                useCustomClass={true}
                maxContentHeight="596px"
                width="512px"
            >
                {React.cloneElement(children, { onClose: () => setIsOpen(false) })}
            </IndexModal>
        </>
    );
};

export default NotificationButton;
